import { useEffect } from 'react';
import { Badge } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { getLogger } from '../../util/logger';
import { USE_BUREAUCRAT_MOCK } from '../../util/config';
import LocalLogin from '../logins/LocalLogin';
import MicrosoftLogin from '../logins/MicrosoftLogin';

const logger = getLogger('Login');

function Login() {
  const auth = useAuth();
  const history = useHistory();

  const { from } = history.location.state || { from: { pathname: '/' } };

  const loginButton = USE_BUREAUCRAT_MOCK ? (
    <LocalLogin />
  ) : (
    <MicrosoftLogin url={auth.url} />
  );

  useEffect(() => {
    if (auth.isLoggedIn) {
      logger.debug(`logged in. redirecting to "${from.pathname}"`);
      history.replace(from);
    }
  }, [auth, history, from]);

  return (
    auth.isLoggedIn === false && (
      <>
        <Badge variant="danger">{auth.apiError}</Badge>
        <p>
          This app activates the Poly RealConnect Service for Microsoft Teams
          and Office 365. Poly RealConnect Service seamlessly connects H.323 and
          SIP video endpoints into a Microsoft Teams or Skype for Business call
          through integrated Outlook or Teams scheduling.
        </p>
        <p>
          To enroll in the Poly RealConnect Service, you must first log in to
          Microsoft Office 365 as a global administrator and authorize this app.
        </p>
        <p>
          After you&apos;ve logged in, you will be automatically redirected back
          here and prompted for further information to continue the enrollment
          process.
        </p>
        <p>{loginButton}</p>
      </>
    )
  );
}

export default Login;
